import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { modalsActions } from '../../features/modals/modalsSlice';
import { adStudiesActions } from '../../store/adStudies/actions';
import { getAdStudiesState } from '../../store/adStudies/reducer';
import { useAppDispatch, useAppSelector } from '../redux/store';

interface IUseAdStudiesProps {
  folderId?: string;
  id?: string;
}
export default function useAdStudies({ folderId, id }: IUseAdStudiesProps) {
  const { activeAdStudy, formTouchStates, localisationFormValues } =
    useAppSelector(getAdStudiesState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (id) {
      dispatch(
        adStudiesActions.fetchAdStudy.request({ idIri: `/ad-studies/${id}` }),
      );
    }
  }, [id]);
  const deleteAdStudies = (currentFolderIdIri: string) => {
    dispatch(adStudiesActions.deleteAdStudies.request(currentFolderIdIri));
  };
  const moveAdStudies = (currentFolderIdIri: string) => {
    dispatch(modalsActions.chooseFolder({ action: 'MOVE', currentFolderIdIri }));
  };
  return {
    activeAdStudy,
    adFull: isEmpty(activeAdStudy) ? null : activeAdStudy.ad,
    formTouchStates,
    localisationFormValues,
    deleteAdStudies,
    moveAdStudies,
  };
}
